// Approved three-act QLine story data transcribed from the master story document.
// Preserve cue IDs, order, wording, and spoken directions. No Voicebox output is embedded here.
import { productionSetups } from './productionSetups.js';

export const approvedStoryRebuilds = {
  "chair": {
    "storyId": "cafe-last-chair",
    "title": "The Last Chair",
    "category": "Comedy",
    "mode": "scripted",
    "targetDuration": "10-15 minutes",
    "protagonist": "Dev",
    "arc": "Dev starts convinced that asking for help will expose how badly he planned. His pride makes him hide a real need behind jokes, bargaining, and competition. He loses the chair because he will not tell the truth, then finally gets the chair only to discover the outlet is dead and his laptop shuts down. At the darkest point, he stops trying to win and simply asks another person for help. That change solves the real problem.",
    "briefs": [
      "Mara | Wants her usual quiet writing chair during the only peaceful hour she gets. Competitive, funny, but able to soften when she sees the real stakes. Secret: her reservation sign is homemade and has no authority.",
      "Dev | Wants power for his laptop before a major presentation. Weakness: he hates asking for help after arriving late and believes he should solve his own mistake. Secret: his battery is at two percent.",
      "Luz | Wants both regulars to stop performing and say what they actually need. Warm, observant, and amused. Secret: the outlet beside the chair has been broken since yesterday, and a working extension cord is behind the counter."
    ],
    "acts": [
      {
        "number": 1,
        "title": "The Chair",
        "setup": "Mara and Dev reach the last chair beside the café's only visible outlet. Dev needs power but refuses to admit how serious it is.",
        "priorEvent": "Dev loses the chair because his own pride keeps him from saying what he needs."
      },
      {
        "number": 2,
        "title": "The Polite War",
        "setup": "Dev keeps trying to solve the problem without asking. The argument gets funnier, but each attempt costs him time and battery.",
        "priorEvent": "Dev finally wins the chair, but the thing he fought for cannot save him. His laptop is dead, the presentation is close, and his old way of handling the problem has failed."
      },
      {
        "number": 3,
        "title": "Ask a Person",
        "setup": "Dev uses what he learned. Instead of bargaining, hiding, or fighting for an object, he asks another person for help.",
        "priorEvent": "Dev loses the chair because he hides his need."
      }
    ],
    "cues": [
      {
        "number": 1,
        "id": "chair-v2-c01",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Oh good. My chair is still open.",
        "directionText": "Reach the chair one second before Dev and put one hand on its back.",
        "spokenDirectionText": "Claim the chair.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 2,
        "id": "chair-v2-c02",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Interesting use of the word \"my.\"",
        "directionText": "Stop beside the chair. Look at Mara's hand, then the outlet.",
        "spokenDirectionText": "Stop beside her.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 3,
        "id": "chair-v2-c03",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "I reserved it. See? \"Mara. 8:00 a.m.\" Very official handwriting.",
        "directionText": "Place your homemade reservation sign on the chair like it settles the matter.",
        "spokenDirectionText": "Place the sign.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 4,
        "id": "chair-v2-c04",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Did the café issue that, or did your kitchen printer get promoted overnight?",
        "directionText": "Tap the sign with one finger, then open your laptop.",
        "spokenDirectionText": "Tap the sign.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 5,
        "id": "chair-v2-c05",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Two percent. Great. Plenty of power if my presentation lasts twelve seconds.",
        "directionText": "See the battery warning and try to hide how badly it scares you.",
        "spokenDirectionText": "Check the laptop.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 6,
        "id": "chair-v2-c06",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "You do not want the chair. You want the outlet.",
        "directionText": "Catch Dev staring at the battery and glance at the outlet.",
        "spokenDirectionText": "Notice the panic.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 7,
        "id": "chair-v2-c07",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "I can want two things. Comfort and electrical survival are not enemies.",
        "directionText": "Shrug too casually and keep pretending this is only a preference.",
        "spokenDirectionText": "Shrug.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 8,
        "id": "chair-v2-c08",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Should I bring hot chocolate, or a tiny flag so one of you can formally conquer the chair?",
        "directionText": "Approach with a towel and study the frozen standoff.",
        "spokenDirectionText": "Join them.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 9,
        "id": "chair-v2-c09",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "New rule. One sentence each. Why do you actually need this chair?",
        "directionText": "Hold up one hand like a mediator and look at Mara first.",
        "spokenDirectionText": "Ask them both.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 10,
        "id": "chair-v2-c10",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "This is my only quiet hour to write before the café fills up. I come early for that.",
        "directionText": "Drop the fake legal argument and answer Luz plainly.",
        "spokenDirectionText": "Answer honestly.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 11,
        "id": "chair-v2-c11",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "I just like the outlet. Very calming. Strong wall energy.",
        "directionText": "Hide the real stakes behind one more joke.",
        "spokenDirectionText": "Play it off.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 12,
        "id": "chair-v2-c12",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Then Mara gets the chair. She gave me a reason. You gave me architecture.",
        "directionText": "Hand Mara the reservation sign back and gesture for her to sit.",
        "spokenDirectionText": "Give the ruling.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 13,
        "id": "chair-v2-c13",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "I can work standing. This cable only needs to be... about three feet longer.",
        "directionText": "Stretch the charger toward the outlet and discover it cannot reach around Mara's chair.",
        "spokenDirectionText": "Test the reach.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 14,
        "id": "chair-v2-c14",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Dev, if you need the outlet that badly, why do you not just ask me?",
        "directionText": "Watch him struggle with the cable instead of enjoying your victory.",
        "spokenDirectionText": "Look at Dev.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 15,
        "id": "chair-v2-c15",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Because I am handling it. Beautifully, obviously.",
        "directionText": "Wave her off while the charger hangs uselessly from your hand.",
        "spokenDirectionText": "Wave her off.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 16,
        "id": "chair-v2-c16",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Fine. Breakfast. I buy yours, you lend me the chair for twenty minutes.",
        "directionText": "Switch from denial to bargaining. Hold up the charger like an offer.",
        "spokenDirectionText": "Offer the trade.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 17,
        "id": "chair-v2-c17",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "So we have moved from fake law to bribery. This café is growing fast.",
        "directionText": "Keep the chair, but let yourself enjoy how ridiculous this has become.",
        "spokenDirectionText": "Reject the bribe.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 18,
        "id": "chair-v2-c18",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Better idea. Before either of you argues for yourself, argue why the other person should get the chair.",
        "directionText": "Step between them again. Make the rule sound completely serious.",
        "spokenDirectionText": "Set the rule.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 19,
        "id": "chair-v2-c19",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Dev has a deadline, a dying laptop, and apparently no backup plan beyond staring intensely at electricity.",
        "directionText": "Look at Dev instead of the chair and make the strongest case you can for him.",
        "spokenDirectionText": "Look at Dev.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 20,
        "id": "chair-v2-c20",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Mara gets here early because this is the only quiet hour she has to write before everybody else shows up.",
        "directionText": "Look at Mara's notebook and make the strongest case you can for her.",
        "spokenDirectionText": "Look at Mara.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 21,
        "id": "chair-v2-c21",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "You noticed that?",
        "directionText": "Let the competition drop for a moment. You did not expect him to understand.",
        "spokenDirectionText": "Soften.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 22,
        "id": "chair-v2-c22",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "One percent. Okay. That number feels less like math and more like a threat.",
        "directionText": "Check the battery again. The warning is now critical.",
        "spokenDirectionText": "Check the battery.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 23,
        "id": "chair-v2-c23",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Sit down, Dev. Use the outlet. I can write from another chair.",
        "directionText": "Lift your bag and reservation sign off the chair before he can bargain again.",
        "spokenDirectionText": "Give the chair.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 24,
        "id": "chair-v2-c24",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Thank you. I should have just told you. I came late, I planned badly, and I did not want to ask you to fix my mistake.",
        "directionText": "Sit, close the laptop halfway, and finally stop pretending.",
        "spokenDirectionText": "Drop the act.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 25,
        "id": "chair-v2-c25",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Come on. Just give me twenty minutes.",
        "directionText": "Plug the charger into the outlet and watch the battery icon.",
        "spokenDirectionText": "Plug it in.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 26,
        "id": "chair-v2-c26",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "I should mention one small detail. That outlet has been broken since yesterday.",
        "directionText": "Wait until Dev realizes the battery is not charging, then point to the dead outlet.",
        "spokenDirectionText": "Point to the outlet.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 27,
        "id": "chair-v2-c27",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "You have got to be kidding me.",
        "directionText": "Watch the laptop screen go black. Freeze with the charger still in your hand.",
        "spokenDirectionText": "Freeze.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 28,
        "id": "chair-v2-c28",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Dev, forget the chair for ten seconds. What do you actually need?",
        "directionText": "Let the joke leave your voice. Give him one clean chance to answer.",
        "spokenDirectionText": "Face Dev.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 29,
        "id": "chair-v2-c29",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "I need power. Fast. I messed this up. Luz, is there any working outlet or extension cord I can borrow?",
        "directionText": "Look directly at Luz and ask without joking, trading, or defending yourself.",
        "spokenDirectionText": "Ask for help.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 30,
        "id": "chair-v2-c30",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Yes. There is a working outlet behind the counter, and I have an extension cord.",
        "directionText": "Reach behind the counter and pull out the coiled extension cord.",
        "spokenDirectionText": "Reveal the cord.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 31,
        "id": "chair-v2-c31",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "You had that the whole time?",
        "directionText": "Stare at Luz, then at the cord, trying to decide whether to laugh or collapse.",
        "spokenDirectionText": "Stare at Luz.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 32,
        "id": "chair-v2-c32",
        "actor": "Luz",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "I had a cord. You had words. We were waiting on the slower system.",
        "directionText": "Hand Dev the cord with a straight face.",
        "spokenDirectionText": "Hand him the cord.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 33,
        "id": "chair-v2-c33",
        "actor": "Mara",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Plug in here. I will keep the chair, you take this side of the table, and nobody has to establish a government.",
        "directionText": "Slide your notebook over and make room for Dev beside you.",
        "spokenDirectionText": "Make room.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 34,
        "id": "chair-v2-c34",
        "actor": "Dev",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "It is back. Presentation recovered. Mara, breakfast is still on me, but this time it is a thank-you, not a bribe.",
        "directionText": "Plug in through the extension cord, wait for the laptop to boot, then turn to Mara.",
        "spokenDirectionText": "Watch it boot.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 35,
        "id": "chair-v2-ending",
        "actor": "selected group",
        "kind": "ending",
        "act": 3,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "",
        "text": "Together make one ridiculous official café rule for the chair. The central problem is already solved. End with Mara getting her quiet writing space, Dev getting power for the presentation, and Luz getting a rule that rewards asking honestly instead of fighting over furniture.",
        "directorVoice": false,
        "requireAck": false
      }
    ],
    "approvedScript": "The Last Chair\nstoryId: cafe-last-chair\nCategory: Comedy\nMode: scripted\nTarget duration: 10-15 minutes\nSource checked: src/data/demoScenario.js, SHA-256 d753f4ffcc4807195f47861bf52dd78497cc5c2050fba4e28589209d0cb38122\nProtagonist: Dev\nArc: Dev starts convinced that asking for help will expose how badly he planned. His pride makes him hide a real need behind jokes, bargaining, and competition. He loses the chair because he will not tell the truth, then finally gets the chair only to discover the outlet is dead and his laptop shuts down. At the darkest point, he stops trying to win and simply asks another person for help. That change solves the real problem.\nComedy engine: Two regulars turn a simple chair dispute into fake law, bribery, mediation, and a tiny government. The payoff is that the chair was never the real solution.\nVoice metadata: Preserve the current QLine/retained-edition voice assignments for Mara, Dev, and Luz. This writing pass does not replace voice IDs or render audio.\n\n\nCharacter Briefs\nMara | Wants her usual quiet writing chair during the only peaceful hour she gets. Competitive, funny, but able to soften when she sees the real stakes. Secret: her reservation sign is homemade and has no authority.\nDev | Wants power for his laptop before a major presentation. Weakness: he hates asking for help after arriving late and believes he should solve his own mistake. Secret: his battery is at two percent.\nLuz | Wants both regulars to stop performing and say what they actually need. Warm, observant, and amused. Secret: the outlet beside the chair has been broken since yesterday, and a working extension cord is behind the counter.\n\n\nAct I - The Chair\nSetup: Mara and Dev reach the last chair beside the café's only visible outlet. Dev needs power but refuses to admit how serious it is.\n\n\nCue 01 | chair-v2-c01 | Mara\ndialogue: Oh good. My chair is still open.\ndirectionText: Reach the chair one second before Dev and put one hand on its back.\nspokenDirectionText: Claim the chair.\n\n\nCue 02 | chair-v2-c02 | Dev\ndialogue: Interesting use of the word \"my.\"\ndirectionText: Stop beside the chair. Look at Mara's hand, then the outlet.\nspokenDirectionText: Stop beside her.\n\n\nCue 03 | chair-v2-c03 | Mara\ndialogue: I reserved it. See? \"Mara. 8:00 a.m.\" Very official handwriting.\ndirectionText: Place your homemade reservation sign on the chair like it settles the matter.\nspokenDirectionText: Place the sign.\n\n\nCue 04 | chair-v2-c04 | Dev\ndialogue: Did the café issue that, or did your kitchen printer get promoted overnight?\ndirectionText: Tap the sign with one finger, then open your laptop.\nspokenDirectionText: Tap the sign.\n\n\nCue 05 | chair-v2-c05 | Dev\ndialogue: Two percent. Great. Plenty of power if my presentation lasts twelve seconds.\ndirectionText: See the battery warning and try to hide how badly it scares you.\nspokenDirectionText: Check the laptop.\n\n\nCue 06 | chair-v2-c06 | Mara\ndialogue: You do not want the chair. You want the outlet.\ndirectionText: Catch Dev staring at the battery and glance at the outlet.\nspokenDirectionText: Notice the panic.\n\n\nCue 07 | chair-v2-c07 | Dev\ndialogue: I can want two things. Comfort and electrical survival are not enemies.\ndirectionText: Shrug too casually and keep pretending this is only a preference.\nspokenDirectionText: Shrug.\n\n\nCue 08 | chair-v2-c08 | Luz\ndialogue: Should I bring hot chocolate, or a tiny flag so one of you can formally conquer the chair?\ndirectionText: Approach with a towel and study the frozen standoff.\nspokenDirectionText: Join them.\n\n\nCue 09 | chair-v2-c09 | Luz\ndialogue: New rule. One sentence each. Why do you actually need this chair?\ndirectionText: Hold up one hand like a mediator and look at Mara first.\nspokenDirectionText: Ask them both.\n\n\nCue 10 | chair-v2-c10 | Mara\ndialogue: This is my only quiet hour to write before the café fills up. I come early for that.\ndirectionText: Drop the fake legal argument and answer Luz plainly.\nspokenDirectionText: Answer honestly.\n\n\nCue 11 | chair-v2-c11 | Dev\ndialogue: I just like the outlet. Very calming. Strong wall energy.\ndirectionText: Hide the real stakes behind one more joke.\nspokenDirectionText: Play it off.\n\n\nCue 12 | chair-v2-c12 | Luz\ndialogue: Then Mara gets the chair. She gave me a reason. You gave me architecture.\ndirectionText: Hand Mara the reservation sign back and gesture for her to sit.\nspokenDirectionText: Give the ruling.\n\n\nAct I disaster: Dev loses the chair because his own pride keeps him from saying what he needs.\n\n\nAct II - The Polite War\nRising action: Dev keeps trying to solve the problem without asking. The argument gets funnier, but each attempt costs him time and battery.\n\n\nCue 13 | chair-v2-c13 | Dev\ndialogue: I can work standing. This cable only needs to be... about three feet longer.\ndirectionText: Stretch the charger toward the outlet and discover it cannot reach around Mara's chair.\nspokenDirectionText: Test the reach.\n\n\nCue 14 | chair-v2-c14 | Mara\ndialogue: Dev, if you need the outlet that badly, why do you not just ask me?\ndirectionText: Watch him struggle with the cable instead of enjoying your victory.\nspokenDirectionText: Look at Dev.\n\n\nCue 15 | chair-v2-c15 | Dev\ndialogue: Because I am handling it. Beautifully, obviously.\ndirectionText: Wave her off while the charger hangs uselessly from your hand.\nspokenDirectionText: Wave her off.\n\n\nCue 16 | chair-v2-c16 | Dev\ndialogue: Fine. Breakfast. I buy yours, you lend me the chair for twenty minutes.\ndirectionText: Switch from denial to bargaining. Hold up the charger like an offer.\nspokenDirectionText: Offer the trade.\n\n\nCue 17 | chair-v2-c17 | Mara\ndialogue: So we have moved from fake law to bribery. This café is growing fast.\ndirectionText: Keep the chair, but let yourself enjoy how ridiculous this has become.\nspokenDirectionText: Reject the bribe.\n\n\nCue 18 | chair-v2-c18 | Luz\ndialogue: Better idea. Before either of you argues for yourself, argue why the other person should get the chair.\ndirectionText: Step between them again. Make the rule sound completely serious.\nspokenDirectionText: Set the rule.\n\n\nCue 19 | chair-v2-c19 | Mara\ndialogue: Dev has a deadline, a dying laptop, and apparently no backup plan beyond staring intensely at electricity.\ndirectionText: Look at Dev instead of the chair and make the strongest case you can for him.\nspokenDirectionText: Look at Dev.\n\n\nCue 20 | chair-v2-c20 | Dev\ndialogue: Mara gets here early because this is the only quiet hour she has to write before everybody else shows up.\ndirectionText: Look at Mara's notebook and make the strongest case you can for her.\nspokenDirectionText: Look at Mara.\n\n\nCue 21 | chair-v2-c21 | Mara\ndialogue: You noticed that?\ndirectionText: Let the competition drop for a moment. You did not expect him to understand.\nspokenDirectionText: Soften.\n\n\nCue 22 | chair-v2-c22 | Dev\ndialogue: One percent. Okay. That number feels less like math and more like a threat.\ndirectionText: Check the battery again. The warning is now critical.\nspokenDirectionText: Check the battery.\n\n\nCue 23 | chair-v2-c23 | Mara\ndialogue: Sit down, Dev. Use the outlet. I can write from another chair.\ndirectionText: Lift your bag and reservation sign off the chair before he can bargain again.\nspokenDirectionText: Give the chair.\n\n\nCue 24 | chair-v2-c24 | Dev\ndialogue: Thank you. I should have just told you. I came late, I planned badly, and I did not want to ask you to fix my mistake.\ndirectionText: Sit, close the laptop halfway, and finally stop pretending.\nspokenDirectionText: Drop the act.\n\n\nCue 25 | chair-v2-c25 | Dev\ndialogue: Come on. Just give me twenty minutes.\ndirectionText: Plug the charger into the outlet and watch the battery icon.\nspokenDirectionText: Plug it in.\n\n\nCue 26 | chair-v2-c26 | Luz\ndialogue: I should mention one small detail. That outlet has been broken since yesterday.\ndirectionText: Wait until Dev realizes the battery is not charging, then point to the dead outlet.\nspokenDirectionText: Point to the outlet.\n\n\nCue 27 | chair-v2-c27 | Dev\ndialogue: You have got to be kidding me.\ndirectionText: Watch the laptop screen go black. Freeze with the charger still in your hand.\nspokenDirectionText: Freeze.\n\n\nDarkest point: Dev finally wins the chair, but the thing he fought for cannot save him. His laptop is dead, the presentation is close, and his old way of handling the problem has failed.\n\n\nAct III - Ask a Person\nResolution: Dev uses what he learned. Instead of bargaining, hiding, or fighting for an object, he asks another person for help.\n\n\nCue 28 | chair-v2-c28 | Luz\ndialogue: Dev, forget the chair for ten seconds. What do you actually need?\ndirectionText: Let the joke leave your voice. Give him one clean chance to answer.\nspokenDirectionText: Face Dev.\n\n\nCue 29 | chair-v2-c29 | Dev\ndialogue: I need power. Fast. I messed this up. Luz, is there any working outlet or extension cord I can borrow?\ndirectionText: Look directly at Luz and ask without joking, trading, or defending yourself.\nspokenDirectionText: Ask for help.\n\n\nCue 30 | chair-v2-c30 | Luz\ndialogue: Yes. There is a working outlet behind the counter, and I have an extension cord.\ndirectionText: Reach behind the counter and pull out the coiled extension cord.\nspokenDirectionText: Reveal the cord.\n\n\nCue 31 | chair-v2-c31 | Dev\ndialogue: You had that the whole time?\ndirectionText: Stare at Luz, then at the cord, trying to decide whether to laugh or collapse.\nspokenDirectionText: Stare at Luz.\n\n\nCue 32 | chair-v2-c32 | Luz\ndialogue: I had a cord. You had words. We were waiting on the slower system.\ndirectionText: Hand Dev the cord with a straight face.\nspokenDirectionText: Hand him the cord.\n\n\nCue 33 | chair-v2-c33 | Mara\ndialogue: Plug in here. I will keep the chair, you take this side of the table, and nobody has to establish a government.\ndirectionText: Slide your notebook over and make room for Dev beside you.\nspokenDirectionText: Make room.\n\n\nCue 34 | chair-v2-c34 | Dev\ndialogue: It is back. Presentation recovered. Mara, breakfast is still on me, but this time it is a thank-you, not a bribe.\ndirectionText: Plug in through the extension cord, wait for the laptop to boot, then turn to Mara.\nspokenDirectionText: Watch it boot.\n\n\nEnding cue | chair-v2-ending | selected group\ntext: Together make one ridiculous official café rule for the chair. The central problem is already solved. End with Mara getting her quiet writing space, Dev getting power for the presentation, and Luz getting a rule that rewards asking honestly instead of fighting over furniture.\n\n\nStory check\nBeginning: clear want, weakness, chair conflict, and Dev's refusal to ask honestly.\nAct I disaster: Dev loses the chair because he hides his need.\nAct II: bargaining, role reversal, empathy, shrinking battery, earned chair, then the broken-outlet reversal.\nDarkest point: the laptop dies after Dev finally gets the chair.\nAct III: Dev asks plainly for help. That changed behavior unlocks the extension cord and solves the real problem.\nCharacter arc: Dev moves from pride and self-protection to honest asking and gratitude.\nComedy: wants drive the jokes; the conflict escalates from fake reservation law to bribery to mediation to the dead-outlet reveal and final payoff.\nCause and effect: Dev's hiding causes the loss; the loss causes escalating tactics; the tactics expose both characters' real needs; honesty earns the chair; the dead outlet exposes that the chair was never the true solution; asking for help solves it."
  },
  "garden": {
    "storyId": "garden-basket-v1",
    "title": "The Garden Basket",
    "category": "Family",
    "mode": "scripted family scene",
    "targetDuration": "",
    "protagonist": "Ben",
    "arc": "Ben starts willing to be kind only when kindness costs him nothing. He claims the best apple for himself and jokes about giving Mrs. Bell a smaller one. When the basket breaks and the apple chosen for Mrs. Bell is ruined, Ben's own perfect apple becomes the only gift that matches their promise. He first tries to avoid the choice. After remembering how Mrs. Bell helped them when their own tree failed, he chooses to give up the apple because he wants to, not because Ada forces him. Ada then shares a bruised apple with him on the walk home.",
    "briefs": [
      "Ada | You want to keep the promise to leave Mrs. Bell a good apple before you and Ben head home. You care about doing the right thing, but do not pressure Ben into giving up what is his. When the basket breaks, stay honest about what happened and look for a fair answer.",
      "Ben | You helped pick the apples and have claimed the biggest, cleanest one as your reward. You like being generous when it is easy, but you do not want generosity to cost you the thing you wanted most. The story will force you to decide what kindness means when it actually costs something."
    ],
    "acts": [
      {
        "number": 1,
        "title": "The Extra Apple",
        "setup": "Ada and Ben finish picking apples and find one more than expected. Ben immediately claims the best apple. Ada remembers their promise to Mrs. Bell.",
        "priorEvent": "The basket breaks. The apple they promised Mrs. Bell is ruined, while the perfect apple Ben claimed for himself is still safe."
      },
      {
        "number": 2,
        "title": "The Cost of Kindness",
        "setup": "Ben looks for a way to keep his apple and still call the promise finished. Ada refuses to take it from him. Fixing the basket and remembering Mrs. Bell's past kindness makes the choice harder.",
        "priorEvent": "Ada gives Ben a real choice. No one is forcing him. If he keeps the apple, their promise waits until tomorrow. Ben has to decide whether kindness still matters when it costs him something he truly wanted."
      },
      {
        "number": 3,
        "title": "The Best One",
        "setup": "Ben changes through action. He gives the apple freely. Ada answers his generosity with sharing of her own.",
        "priorEvent": "The basket breaks and ruins the apple chosen for Mrs. Bell."
      }
    ],
    "cues": [
      {
        "number": 1,
        "id": "garden-v2-c01",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Wait. We counted twelve apples, but there are thirteen in the basket.",
        "directionText": "Count the apples again and stop when the number still comes out wrong.",
        "spokenDirectionText": "Count again.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 2,
        "id": "garden-v2-c02",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Then the tree has excellent customer service. I call the biggest one.",
        "directionText": "Pick up the biggest clean apple and hold it like you have won a prize.",
        "spokenDirectionText": "Claim the apple.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 3,
        "id": "garden-v2-c03",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Mrs. Bell asked us to leave one by her gate. I almost forgot.",
        "directionText": "Remember the promise and look from Ben's apple back to the basket.",
        "spokenDirectionText": "Remember the promise.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 4,
        "id": "garden-v2-c04",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Great. We give her the tiny one, and generosity remains affordable.",
        "directionText": "Choose the smallest apple in the basket and offer it with a hopeful grin.",
        "spokenDirectionText": "Offer the small one.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 5,
        "id": "garden-v2-c05",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "No. We promised her a good one. Let's give her this big red one.",
        "directionText": "Pick a good apple from the basket and set it aside for Mrs. Bell.",
        "spokenDirectionText": "Choose her apple.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 6,
        "id": "garden-v2-c06",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Fine. I will carry the basket if you want me to suffer nobly.",
        "directionText": "Take the basket by the handle and lift it. Let the weak handle give way as you raise it.",
        "spokenDirectionText": "Lift the basket.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 7,
        "id": "garden-v2-c07",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Ben, stop. The handle tore. Apples everywhere... and Mrs. Bell's apple split on the stone.",
        "directionText": "Kneel beside the spilled apples and pick up the apple that was set aside.",
        "spokenDirectionText": "Check her apple.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 8,
        "id": "garden-v2-c08",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Okay. New plan. Pick another one with fewer battle scars.",
        "directionText": "Gather two bruised apples and compare them as if one must be good enough.",
        "spokenDirectionText": "Check the others.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 9,
        "id": "garden-v2-c09",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "I am checking. Most of the big ones got bruised. Yours is the only big apple that came through clean.",
        "directionText": "Look through the basket carefully, then glance at the apple Ben is holding.",
        "spokenDirectionText": "Look at his apple.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 10,
        "id": "garden-v2-c10",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Mine? This apple survived a basket explosion. It has earned retirement.",
        "directionText": "Pull your apple a little closer and make the joke bigger than your discomfort.",
        "spokenDirectionText": "Hold it close.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 11,
        "id": "garden-v2-c11",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "I am not taking it from you. It is yours. Help me fix the handle, and we will figure something else out.",
        "directionText": "Let Ben keep the apple. Set the basket upright and hold the torn handle together.",
        "spokenDirectionText": "Hold the handle.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 12,
        "id": "garden-v2-c12",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Hold that side. If this knot fails, I am blaming kindness.",
        "directionText": "Tie the loose strap or mime tying it while Ada holds the basket steady.",
        "spokenDirectionText": "Tie the strap.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 13,
        "id": "garden-v2-c13",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Remember last year when our tree froze? Mrs. Bell brought us apples every week. That is why I wanted to bring her a good one today.",
        "directionText": "Test the repaired handle, then look toward the path to Mrs. Bell's gate.",
        "spokenDirectionText": "Look toward the gate.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 14,
        "id": "garden-v2-c14",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "That is very inconvenient information while I am holding the only perfect apple.",
        "directionText": "Look at the apple in your hand, then toward the gate.",
        "spokenDirectionText": "Look at the gate.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 15,
        "id": "garden-v2-c15",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Keep it. I mean it. We will tell her the truth. We made a promise, then the basket broke. We can bring another tomorrow.",
        "directionText": "Close the basket and prepare to leave without reaching for Ben's apple.",
        "spokenDirectionText": "Close the basket.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 16,
        "id": "garden-v2-c16",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "So she gets nothing today because I want the apple I claimed first.",
        "directionText": "Stop walking. Let the words sound less funny once you hear yourself say them.",
        "spokenDirectionText": "Stop walking.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 17,
        "id": "garden-v2-c17",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Ben, you do not have to prove anything. It is your apple.",
        "directionText": "Face Ben and leave your hands at your sides so the choice is clearly his.",
        "spokenDirectionText": "Face Ben.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 18,
        "id": "garden-v2-c18",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "I know. That is why I can choose. Put this one by her gate. The good one.",
        "directionText": "Place your perfect apple into Ada's hands and let go of it.",
        "spokenDirectionText": "Give her the apple.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 19,
        "id": "garden-v2-c19",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Then we split this bruised one on the way home. The bruise is tiny, and I am not letting generosity make you hungry.",
        "directionText": "Pick a slightly bruised apple from the basket and hold it up for Ben to see.",
        "spokenDirectionText": "Pick one to share.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 20,
        "id": "garden-v2-c20",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Deal. Mrs. Bell gets the best one, we get the weird one, and the tree loses customer service privileges.",
        "directionText": "Take the repaired basket and start toward Mrs. Bell's gate beside Ada.",
        "spokenDirectionText": "Start walking.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 21,
        "id": "garden-v2-ending",
        "actor": "selected group",
        "kind": "ending",
        "act": 3,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "",
        "text": "Together leave Ben's apple by Mrs. Bell's gate and decide on one short note to leave with it. The central problem is already solved. End with Ben carrying the repaired basket and Ada planning to split the bruised apple with him on the walk home.",
        "directorVoice": false,
        "requireAck": false
      }
    ],
    "approvedScript": "The Garden Basket - Google Docs Rebuild\nstoryId: garden-basket-v1\nQLine scenario id: family-garden-basket-v1\nCategory: Family\nMode: scripted family scene\nSource checked: src/core/familyCatalog.js\nSource SHA-256: 460e84a91538c0dabfc66e142eeca46261c416dacdcebcd6e111df126d36083e\nProduction setup checked: src/data/productionSetups.js\nProduction setup SHA-256: 175d5ff18480a8f6f67e2045d5d727bcc9681eda3c891e9ac887fa4262edf543\nCue count: 21 total (20 fixed dialogue + 1 ending)\nProtagonist: Ben\nArc: Ben starts willing to be kind only when kindness costs him nothing. He claims the best apple for himself and jokes about giving Mrs. Bell a smaller one. When the basket breaks and the apple chosen for Mrs. Bell is ruined, Ben's own perfect apple becomes the only gift that matches their promise. He first tries to avoid the choice. After remembering how Mrs. Bell helped them when their own tree failed, he chooses to give up the apple because he wants to, not because Ada forces him. Ada then shares a bruised apple with him on the walk home.\nVoice metadata: Preserve the current QLine or retained-edition voice assignments for Ada and Ben. No explicit voice IDs are stored in the familyCatalog.js story source inspected in this pass.\n\n\nCharacter Briefs\nAda | You want to keep the promise to leave Mrs. Bell a good apple before you and Ben head home. You care about doing the right thing, but do not pressure Ben into giving up what is his. When the basket breaks, stay honest about what happened and look for a fair answer.\nBen | You helped pick the apples and have claimed the biggest, cleanest one as your reward. You like being generous when it is easy, but you do not want generosity to cost you the thing you wanted most. The story will force you to decide what kindness means when it actually costs something.\n\n\nAct I - The Extra Apple\nSetup: Ada and Ben finish picking apples and find one more than expected. Ben immediately claims the best apple. Ada remembers their promise to Mrs. Bell.\n\n\nCue 01 | garden-v2-c01 | Ada\ndialogue: Wait. We counted twelve apples, but there are thirteen in the basket.\ndirectionText: Count the apples again and stop when the number still comes out wrong.\nspokenDirectionText: Count again.\n\n\nCue 02 | garden-v2-c02 | Ben\ndialogue: Then the tree has excellent customer service. I call the biggest one.\ndirectionText: Pick up the biggest clean apple and hold it like you have won a prize.\nspokenDirectionText: Claim the apple.\n\n\nCue 03 | garden-v2-c03 | Ada\ndialogue: Mrs. Bell asked us to leave one by her gate. I almost forgot.\ndirectionText: Remember the promise and look from Ben's apple back to the basket.\nspokenDirectionText: Remember the promise.\n\n\nCue 04 | garden-v2-c04 | Ben\ndialogue: Great. We give her the tiny one, and generosity remains affordable.\ndirectionText: Choose the smallest apple in the basket and offer it with a hopeful grin.\nspokenDirectionText: Offer the small one.\n\n\nCue 05 | garden-v2-c05 | Ada\ndialogue: No. We promised her a good one. Let's give her this big red one.\ndirectionText: Pick a good apple from the basket and set it aside for Mrs. Bell.\nspokenDirectionText: Choose her apple.\n\n\nCue 06 | garden-v2-c06 | Ben\ndialogue: Fine. I will carry the basket if you want me to suffer nobly.\ndirectionText: Take the basket by the handle and lift it. Let the weak handle give way as you raise it.\nspokenDirectionText: Lift the basket.\n\n\nCue 07 | garden-v2-c07 | Ada\ndialogue: Ben, stop. The handle tore. Apples everywhere... and Mrs. Bell's apple split on the stone.\ndirectionText: Kneel beside the spilled apples and pick up the apple that was set aside.\nspokenDirectionText: Check her apple.\n\n\nAct I disaster: The basket breaks. The apple they promised Mrs. Bell is ruined, while the perfect apple Ben claimed for himself is still safe.\n\n\n\n\nAct II - The Cost of Kindness\nRising action: Ben looks for a way to keep his apple and still call the promise finished. Ada refuses to take it from him. Fixing the basket and remembering Mrs. Bell's past kindness makes the choice harder.\n\n\nCue 08 | garden-v2-c08 | Ben\ndialogue: Okay. New plan. Pick another one with fewer battle scars.\ndirectionText: Gather two bruised apples and compare them as if one must be good enough.\nspokenDirectionText: Check the others.\n\n\nCue 09 | garden-v2-c09 | Ada\ndialogue: I am checking. Most of the big ones got bruised. Yours is the only big apple that came through clean.\ndirectionText: Look through the basket carefully, then glance at the apple Ben is holding.\nspokenDirectionText: Look at his apple.\n\n\nCue 10 | garden-v2-c10 | Ben\ndialogue: Mine? This apple survived a basket explosion. It has earned retirement.\ndirectionText: Pull your apple a little closer and make the joke bigger than your discomfort.\nspokenDirectionText: Hold it close.\n\n\nCue 11 | garden-v2-c11 | Ada\ndialogue: I am not taking it from you. It is yours. Help me fix the handle, and we will figure something else out.\ndirectionText: Let Ben keep the apple. Set the basket upright and hold the torn handle together.\nspokenDirectionText: Hold the handle.\n\n\nCue 12 | garden-v2-c12 | Ben\ndialogue: Hold that side. If this knot fails, I am blaming kindness.\ndirectionText: Tie the loose strap or mime tying it while Ada holds the basket steady.\nspokenDirectionText: Tie the strap.\n\n\nCue 13 | garden-v2-c13 | Ada\ndialogue: Remember last year when our tree froze? Mrs. Bell brought us apples every week. That is why I wanted to bring her a good one today.\ndirectionText: Test the repaired handle, then look toward the path to Mrs. Bell's gate.\nspokenDirectionText: Look toward the gate.\n\n\nCue 14 | garden-v2-c14 | Ben\ndialogue: That is very inconvenient information while I am holding the only perfect apple.\ndirectionText: Look at the apple in your hand, then toward the gate.\nspokenDirectionText: Look at the gate.\n\n\nCue 15 | garden-v2-c15 | Ada\ndialogue: Keep it. I mean it. We will tell her the truth. We made a promise, then the basket broke. We can bring another tomorrow.\ndirectionText: Close the basket and prepare to leave without reaching for Ben's apple.\nspokenDirectionText: Close the basket.\n\n\nCue 16 | garden-v2-c16 | Ben\ndialogue: So she gets nothing today because I want the apple I claimed first.\ndirectionText: Stop walking. Let the words sound less funny once you hear yourself say them.\nspokenDirectionText: Stop walking.\n\n\nDarkest point: Ada gives Ben a real choice. No one is forcing him. If he keeps the apple, their promise waits until tomorrow. Ben has to decide whether kindness still matters when it costs him something he truly wanted.\n\n\n\n\nAct III - The Best One\nResolution: Ben changes through action. He gives the apple freely. Ada answers his generosity with sharing of her own.\n\n\nCue 17 | garden-v2-c17 | Ada\ndialogue: Ben, you do not have to prove anything. It is your apple.\ndirectionText: Face Ben and leave your hands at your sides so the choice is clearly his.\nspokenDirectionText: Face Ben.\n\n\nCue 18 | garden-v2-c18 | Ben\ndialogue: I know. That is why I can choose. Put this one by her gate. The good one.\ndirectionText: Place your perfect apple into Ada's hands and let go of it.\nspokenDirectionText: Give her the apple.\n\n\nCue 19 | garden-v2-c19 | Ada\ndialogue: Then we split this bruised one on the way home. The bruise is tiny, and I am not letting generosity make you hungry.\ndirectionText: Pick a slightly bruised apple from the basket and hold it up for Ben to see.\nspokenDirectionText: Pick one to share.\n\n\nCue 20 | garden-v2-c20 | Ben\ndialogue: Deal. Mrs. Bell gets the best one, we get the weird one, and the tree loses customer service privileges.\ndirectionText: Take the repaired basket and start toward Mrs. Bell's gate beside Ada.\nspokenDirectionText: Start walking.\n\n\nEnding cue | garden-v2-ending | selected group\ntext: Together leave Ben's apple by Mrs. Bell's gate and decide on one short note to leave with it. The central problem is already solved. End with Ben carrying the repaired basket and Ada planning to split the bruised apple with him on the walk home.\n\n\nStory check\nBeginning: The extra apple creates a chance to be kind, and Ben immediately shows his weakness by protecting the best apple for himself.\nAct I disaster: The basket breaks and ruins the apple chosen for Mrs. Bell.\nAct II: Ben searches for cheaper ways to keep the promise. Ada refuses to force him. The repaired basket solves the physical problem, but remembering Mrs. Bell's past kindness makes the moral choice harder.\nDarkest point: Ben can keep the apple, but doing so means Mrs. Bell receives nothing today.\nAct III: Ben gives the apple because he chooses to. Ada shares another apple with him, so the ending rewards generosity without making it feel like punishment.\nCharacter arc: Ben moves from low-cost kindness to willing sacrifice.\nComedy: The jokes grow from the extra apple to cheap generosity, a broken handle, the surviving perfect apple, and the final customer-service callback.\nCause and effect: Ben claims the best apple. The broken basket ruins the promised apple. That makes Ben's apple the real choice. Mrs. Bell's past kindness raises the cost of keeping it. Ada gives Ben freedom, and Ben uses that freedom to change."
  },
  "paper": {
    "storyId": "paper-bridge-v1",
    "title": "The Paper Bridge",
    "category": "Family",
    "mode": "scripted family scene",
    "targetDuration": "",
    "protagonist": "Ada",
    "arc": "Ada wants to make the paper bridge work quickly and prove she can solve the problem. Her weakness is impatience. She reaches for a fix before she has really looked at what failed. Her rushing causes the first support to be placed without checking, then causes a second overcorrection that makes the bridge worse and flattens their last clean support strip. At the darkest point, Ada thinks she has ruined the project. In Act III she changes her behavior. She lets Ben hold the bridge, waits, watches what actually moves, and makes one measured adjustment instead of grabbing at the problem. That patient cooperation earns the successful crossing.",
    "briefs": [
      "Ada | You want the paper bridge to hold the little sheep, and you want to solve it fast. You are good at spotting problems, but when you get frustrated you rush to fix them before you understand them. The story will force you to slow down, trust Ben, and use what you actually observe.",
      "Ben | You want the bridge to work too. You joke when things go wrong, but you are more patient than Ada and notice small changes in how the bridge bends. Help without taking over. When Ada finally slows down, give her room to make the final choice."
    ],
    "acts": [
      {
        "number": 1,
        "title": "The Fast Fix",
        "setup": "Ada and Ben are together at the craft table with their paper bridge, spare support strip, and little sheep. The bridge has already failed once. Ada wants a quick fix and does not want to start over.",
        "priorEvent": "Ada rushes the support into the center without checking how the bridge is actually failing. The bridge tips left, the sheep falls, and the new support slips out. Her quick answer has made the problem more complicated."
      },
      {
        "number": 2,
        "title": "Chasing the Problem",
        "setup": "Ben tries to slow the process down, but Ada still wants the fastest visible fix. Her next choice overcorrects the bridge and damages the only spare support they have.",
        "priorEvent": "Ada's second rushed fix makes the bridge fail the opposite way and flattens their only spare support. She believes her impatience has ruined the project and that there is nothing useful left to try."
      },
      {
        "number": 3,
        "title": "Look Before Fixing",
        "setup": "Ada changes the way she solves the problem. She stops grabbing for the answer, lets Ben help, studies the bridge, and makes one measured adjustment based on what they actually see.",
        "priorEvent": "Ada insists the support belongs in the center without checking. The bridge tips left and the sheep falls."
      }
    ],
    "cues": [
      {
        "number": 1,
        "id": "paper-v2-c01",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Okay. The sheep made it halfway across before our bridge became a paper taco. We are fixing this one. No starting over.",
        "directionText": "Study the bent bridge and hold it up enough to see where it sagged.",
        "spokenDirectionText": "Study the bridge.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 2,
        "id": "paper-v2-c02",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "That is still better than our first bridge. The first one became the floor.",
        "directionText": "Lift the flattened edge and compare it to the table with a straight face.",
        "spokenDirectionText": "Lift the bridge.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 3,
        "id": "paper-v2-c03",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "The middle keeps bending. We need something underneath it.",
        "directionText": "Press lightly on the middle of the bridge and watch it dip.",
        "spokenDirectionText": "Press the middle.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 4,
        "id": "paper-v2-c04",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "What if I fold this extra strip into a triangle?",
        "directionText": "Pick up the spare paper strip and fold it into a simple triangular support.",
        "spokenDirectionText": "Fold the strip.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 5,
        "id": "paper-v2-c05",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Do it. Move the sheep first. He has suffered enough.",
        "directionText": "Move the little sheep away from the bridge and clear the center.",
        "spokenDirectionText": "Move the sheep.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 6,
        "id": "paper-v2-c06",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Triangle ready. Want to check where it needs to go?",
        "directionText": "Hold the folded support under the bridge without setting it down yet.",
        "spokenDirectionText": "Hold the support.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 7,
        "id": "paper-v2-c07",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Center. The bend is in the center. Easy.",
        "directionText": "Point to the center and answer before checking either side.",
        "spokenDirectionText": "Point to center.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 8,
        "id": "paper-v2-c08",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "All right. Support is in place. Send in the brave test sheep.",
        "directionText": "Place the folded support where Ada pointed, then take your hands away.",
        "spokenDirectionText": "Place the support.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 9,
        "id": "paper-v2-c09",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "One step. Two steps. Three... nope! Left side!",
        "directionText": "Walk the sheep across the bridge until the left side dips and the sheep slides off.",
        "spokenDirectionText": "Walk the sheep.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 10,
        "id": "paper-v2-c10",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Wait. Do not touch it. Look at what dropped first.",
        "directionText": "Freeze before either of you moves the bridge and point toward the side that dipped.",
        "spokenDirectionText": "Freeze.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 11,
        "id": "paper-v2-c11",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "The left side. So we move the support left.",
        "directionText": "Point to the left side and immediately reach toward the folded support.",
        "spokenDirectionText": "Point left.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 12,
        "id": "paper-v2-c12",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "A little left. We do not know how much yet.",
        "directionText": "Raise one hand and ask Ada to wait before making a large adjustment.",
        "spokenDirectionText": "Ask her to wait.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 13,
        "id": "paper-cue-13",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "If a little is good, more is faster.",
        "directionText": "Move the support much farther left than Ben suggested.",
        "spokenDirectionText": "Move it left.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 14,
        "id": "paper-v2-c14",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "That sentence has ruined a lot of crafts.",
        "directionText": "Pick up the sheep and hold it at the start of the bridge.",
        "spokenDirectionText": "Ready the sheep.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 15,
        "id": "paper-v2-c15",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Test sheep, round two. One... two... and now the right side is dropping. Come on!",
        "directionText": "Walk the sheep onto the bridge until the right side dips and the support folds flat.",
        "spokenDirectionText": "Test it again.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 16,
        "id": "paper-v2-c16",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "We did not fix the bridge. We moved the problem.",
        "directionText": "Point from the left side to the right side and leave the bridge untouched.",
        "spokenDirectionText": "Point right.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 17,
        "id": "paper-v2-c17",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "And I flattened the support. Great. That was our last clean strip.",
        "directionText": "Pick up the flattened support and stare at the new crease.",
        "spokenDirectionText": "Pick it up.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 18,
        "id": "paper-v2-c18",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "It is still paper. I can fold it again. But can we stop guessing?",
        "directionText": "Refold the same strip carefully along its strongest crease.",
        "spokenDirectionText": "Refold the strip.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 19,
        "id": "paper-v2-c19",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Yes. You hold the bridge. I am not touching anything for five whole seconds.",
        "directionText": "Step your hands away from the bridge and give Ben space to hold it steady.",
        "spokenDirectionText": "Step back.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 20,
        "id": "paper-v2-c20",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Left side dips first, but barely. The support was almost right before.",
        "directionText": "Press the bridge gently in the middle and watch which side moves first.",
        "spokenDirectionText": "Press the bridge.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 21,
        "id": "paper-v2-c21",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Then the idea was not wrong. The position was wrong. Move it one inch toward me. Just one.",
        "directionText": "Point to the support without touching it and show Ben the small move you mean.",
        "spokenDirectionText": "Point to support.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 22,
        "id": "paper-v2-c22",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "There. Try the sheep again.",
        "directionText": "Move the support the small distance Ada chose, then take your hands away.",
        "spokenDirectionText": "Move it closer.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 23,
        "id": "paper-v2-c23",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "One step. Two. Three... four. He is crossing. He is actually crossing!",
        "directionText": "Walk the sheep slowly across the bridge and stop only after it reaches the other side.",
        "spokenDirectionText": "Walk the sheep.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 24,
        "id": "paper-v2-c24",
        "actor": "Ben",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "We made a bridge out of paper and stubbornness.",
        "directionText": "Celebrate the successful crossing without bumping the bridge.",
        "spokenDirectionText": "Celebrate.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 25,
        "id": "paper-v2-c25",
        "actor": "Ada",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Mostly teamwork. And me finally looking before fixing.",
        "directionText": "Nudge Ben lightly, then look back at the bridge without adjusting it.",
        "spokenDirectionText": "Nudge Ben.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 26,
        "id": "paper-v2-ending",
        "actor": "selected group",
        "kind": "ending",
        "act": 3,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "",
        "text": "Together give the finished bridge a ridiculous official name and walk the sheep across one last time. The central problem is already solved. End with Ada resisting the urge to adjust the bridge while Ben announces that the sheep has survived another crossing.",
        "directorVoice": false,
        "requireAck": false
      }
    ],
    "approvedScript": "The Paper Bridge - Google Docs Rebuild\nstoryId: paper-bridge-v1\nQLine scenario id: family-paper-bridge-v1\nCategory: Family\nMode: scripted family scene\nSource checked: src/core/familyCatalog.js\nSource SHA-256: 460e84a91538c0dabfc66e142eeca46261c416dacdcebcd6e111df126d36083e\nProduction setup checked: src/data/productionSetups.js\nProduction setup SHA-256: 175d5ff18480a8f6f67e2045d5d727bcc9681eda3c891e9ac887fa4262edf543\nCue count: 26 total (25 fixed dialogue + 1 ending)\nProtagonist: Ada\nArc: Ada wants to make the paper bridge work quickly and prove she can solve the problem. Her weakness is impatience. She reaches for a fix before she has really looked at what failed. Her rushing causes the first support to be placed without checking, then causes a second overcorrection that makes the bridge worse and flattens their last clean support strip. At the darkest point, Ada thinks she has ruined the project. In Act III she changes her behavior. She lets Ben hold the bridge, waits, watches what actually moves, and makes one measured adjustment instead of grabbing at the problem. That patient cooperation earns the successful crossing.\nVoice metadata: Preserve the current QLine or retained-edition voice assignments for Ada and Ben. No explicit voice IDs are stored in the familyCatalog.js story source inspected in this pass.\n\n\nCharacter Briefs\nAda | You want the paper bridge to hold the little sheep, and you want to solve it fast. You are good at spotting problems, but when you get frustrated you rush to fix them before you understand them. The story will force you to slow down, trust Ben, and use what you actually observe.\nBen | You want the bridge to work too. You joke when things go wrong, but you are more patient than Ada and notice small changes in how the bridge bends. Help without taking over. When Ada finally slows down, give her room to make the final choice.\n\n\nAct I - The Fast Fix\nSetup: Ada and Ben are together at the craft table with their paper bridge, spare support strip, and little sheep. The bridge has already failed once. Ada wants a quick fix and does not want to start over.\nCue 01 | paper-v2-c01 | Ada\ndialogue: Okay. The sheep made it halfway across before our bridge became a paper taco. We are fixing this one. No starting over.\ndirectionText: Study the bent bridge and hold it up enough to see where it sagged.\nspokenDirectionText: Study the bridge.\nCue 02 | paper-v2-c02 | Ben\ndialogue: That is still better than our first bridge. The first one became the floor.\ndirectionText: Lift the flattened edge and compare it to the table with a straight face.\nspokenDirectionText: Lift the bridge.\nCue 03 | paper-v2-c03 | Ada\ndialogue: The middle keeps bending. We need something underneath it.\ndirectionText: Press lightly on the middle of the bridge and watch it dip.\nspokenDirectionText: Press the middle.\nCue 04 | paper-v2-c04 | Ben\ndialogue: What if I fold this extra strip into a triangle?\ndirectionText: Pick up the spare paper strip and fold it into a simple triangular support.\nspokenDirectionText: Fold the strip.\nCue 05 | paper-v2-c05 | Ada\ndialogue: Do it. Move the sheep first. He has suffered enough.\ndirectionText: Move the little sheep away from the bridge and clear the center.\nspokenDirectionText: Move the sheep.\nCue 06 | paper-v2-c06 | Ben\ndialogue: Triangle ready. Want to check where it needs to go?\ndirectionText: Hold the folded support under the bridge without setting it down yet.\nspokenDirectionText: Hold the support.\nCue 07 | paper-v2-c07 | Ada\ndialogue: Center. The bend is in the center. Easy.\ndirectionText: Point to the center and answer before checking either side.\nspokenDirectionText: Point to center.\nCue 08 | paper-v2-c08 | Ben\ndialogue: All right. Support is in place. Send in the brave test sheep.\ndirectionText: Place the folded support where Ada pointed, then take your hands away.\nspokenDirectionText: Place the support.\nCue 09 | paper-v2-c09 | Ada\ndialogue: One step. Two steps. Three... nope! Left side!\ndirectionText: Walk the sheep across the bridge until the left side dips and the sheep slides off.\nspokenDirectionText: Walk the sheep.\nAct I disaster: Ada rushes the support into the center without checking how the bridge is actually failing. The bridge tips left, the sheep falls, and the new support slips out. Her quick answer has made the problem more complicated.\nAct II - Chasing the Problem\nRising action: Ben tries to slow the process down, but Ada still wants the fastest visible fix. Her next choice overcorrects the bridge and damages the only spare support they have.\nCue 10 | paper-v2-c10 | Ben\ndialogue: Wait. Do not touch it. Look at what dropped first.\ndirectionText: Freeze before either of you moves the bridge and point toward the side that dipped.\nspokenDirectionText: Freeze.\nCue 11 | paper-v2-c11 | Ada\ndialogue: The left side. So we move the support left.\ndirectionText: Point to the left side and immediately reach toward the folded support.\nspokenDirectionText: Point left.\nCue 12 | paper-v2-c12 | Ben\ndialogue: A little left. We do not know how much yet.\ndirectionText: Raise one hand and ask Ada to wait before making a large adjustment.\nspokenDirectionText: Ask her to wait.\nCue 13 | paper-cue-13 | Ada\ndialogue: If a little is good, more is faster.\ndirectionText: Move the support much farther left than Ben suggested.\nspokenDirectionText: Move it left.\nCue 14 | paper-v2-c14 | Ben\ndialogue: That sentence has ruined a lot of crafts.\ndirectionText: Pick up the sheep and hold it at the start of the bridge.\nspokenDirectionText: Ready the sheep.\nCue 15 | paper-v2-c15 | Ada\ndialogue: Test sheep, round two. One... two... and now the right side is dropping. Come on!\ndirectionText: Walk the sheep onto the bridge until the right side dips and the support folds flat.\nspokenDirectionText: Test it again.\nCue 16 | paper-v2-c16 | Ben\ndialogue: We did not fix the bridge. We moved the problem.\ndirectionText: Point from the left side to the right side and leave the bridge untouched.\nspokenDirectionText: Point right.\nCue 17 | paper-v2-c17 | Ada\ndialogue: And I flattened the support. Great. That was our last clean strip.\ndirectionText: Pick up the flattened support and stare at the new crease.\nspokenDirectionText: Pick it up.\nDarkest point: Ada's second rushed fix makes the bridge fail the opposite way and flattens their only spare support. She believes her impatience has ruined the project and that there is nothing useful left to try.\nAct III - Look Before Fixing\nResolution: Ada changes the way she solves the problem. She stops grabbing for the answer, lets Ben help, studies the bridge, and makes one measured adjustment based on what they actually see.\nCue 18 | paper-v2-c18 | Ben\ndialogue: It is still paper. I can fold it again. But can we stop guessing?\ndirectionText: Refold the same strip carefully along its strongest crease.\nspokenDirectionText: Refold the strip.\nCue 19 | paper-v2-c19 | Ada\ndialogue: Yes. You hold the bridge. I am not touching anything for five whole seconds.\ndirectionText: Step your hands away from the bridge and give Ben space to hold it steady.\nspokenDirectionText: Step back.\nCue 20 | paper-v2-c20 | Ben\ndialogue: Left side dips first, but barely. The support was almost right before.\ndirectionText: Press the bridge gently in the middle and watch which side moves first.\nspokenDirectionText: Press the bridge.\nCue 21 | paper-v2-c21 | Ada\ndialogue: Then the idea was not wrong. The position was wrong. Move it one inch toward me. Just one.\ndirectionText: Point to the support without touching it and show Ben the small move you mean.\nspokenDirectionText: Point to support.\nCue 22 | paper-v2-c22 | Ben\ndialogue: There. Try the sheep again.\ndirectionText: Move the support the small distance Ada chose, then take your hands away.\nspokenDirectionText: Move it closer.\nCue 23 | paper-v2-c23 | Ada\ndialogue: One step. Two. Three... four. He is crossing. He is actually crossing!\ndirectionText: Walk the sheep slowly across the bridge and stop only after it reaches the other side.\nspokenDirectionText: Walk the sheep.\nCue 24 | paper-v2-c24 | Ben\ndialogue: We made a bridge out of paper and stubbornness.\ndirectionText: Celebrate the successful crossing without bumping the bridge.\nspokenDirectionText: Celebrate.\nCue 25 | paper-v2-c25 | Ada\ndialogue: Mostly teamwork. And me finally looking before fixing.\ndirectionText: Nudge Ben lightly, then look back at the bridge without adjusting it.\nspokenDirectionText: Nudge Ben.\nEnding cue | paper-v2-ending | selected group\ntext: Together give the finished bridge a ridiculous official name and walk the sheep across one last time. The central problem is already solved. End with Ada resisting the urge to adjust the bridge while Ben announces that the sheep has survived another crossing.\nStory check\nBeginning: Ada and Ben already have a failed bridge, a clear goal, and one spare support. Ada's weakness appears immediately because she wants the fastest answer instead of the best observation.\nAct I disaster: Ada insists the support belongs in the center without checking. The bridge tips left and the sheep falls.\nAct II: Ben asks Ada to observe. Ada notices the left drop but overcorrects anyway. The next test fails on the other side and flattens their only spare support.\nDarkest point: Ada believes her rushing has ruined the last useful piece of paper and that the bridge is finished.\nAct III: Ada stops touching the bridge, lets Ben help, watches the actual movement, and makes one measured adjustment. The bridge holds.\nCharacter arc: Ada moves from impatient solo fixing to patient, evidence-based cooperation.\nComedy: The paper taco, the floor bridge, the brave test sheep, the craft-warning joke, and the stubbornness payoff all come from the characters' real goal.\nCause and effect: Ada rushes the first placement, which causes the first failure. She overcorrects, which causes the opposite failure and damages the support. That consequence finally changes her approach. She slows down, works with Ben, observes first, and solves the bridge problem"
  },
  "switch": {
    "storyId": "improv-switchboard",
    "title": "Switchboard 9",
    "category": "Improv",
    "mode": "improv",
    "targetDuration": "12–18 minutes",
    "protagonist": "Operator Nine",
    "arc": "Operator Nine wants one perfect final call before leaving the switchboard. Nine believes a good operator solves every problem by finding the exact department and keeping every line neat. The harder Nine tries to separate the callers, the more the switchboard proves their problems belong together. At the darkest point, the only helpful choice is a manual bridge that will end Nine's perfect routing record. Nine gives up the record, connects the callers directly, and learns that helping people matters more than making the call look perfect.",
    "briefs": [
      "Operator Nine: This is your final shift. You want one perfect call before you leave. You are calm because you know every department and every rule. Your weakness is that you treat a strange human problem like a routing problem. You hate crossed lines and hate admitting that the right answer may be no transfer at all. Keep both callers connected and help them without disconnecting anyone.",
      "Caller A: You called the Department of Lost Things because you have lost a feeling, not an object. The feeling disappeared after a painful moment with someone close to you. Describe it through weather, temperature, body feelings, and memories before you name it. You want Operator Nine to guess because saying the feeling out loud would make the real problem harder to avoid.",
      "Caller B: You claim you are calling from tomorrow because every spoon will vanish at noon. You are really in the same room as Caller A. The future emergency is fake. You invented it because Caller A has been avoiding a hard conversation with you, and you hoped a ridiculous crisis might make the two of you talk. Keep the future story alive as long as you can, but let real details from the room slip out."
    ],
    "acts": [
      {
        "number": 1,
        "title": "One Perfect Call",
        "setup": "Operator Nine begins the final shift wanting one clean, perfect call. Caller A reports losing something that cannot be placed in a box. Nine tries to solve the problem by finding the correct department instead of noticing that the caller needs a person more than a transfer.",
        "priorEvent": "Nine's need for one perfect, orderly call is broken. A second caller crashes into the first line, and the two problems begin touching each other before Nine is ready."
      },
      {
        "number": 2,
        "title": "Crossed Wires",
        "setup": "Operator Nine tries to restore order by separating the calls. Instead, each new clue proves the calls share the same room and the same real problem.",
        "priorEvent": "Nine can preserve the perfect record only by continuing to treat the callers like separate routing problems. The helpful choice will make the final shift look imperfect."
      },
      {
        "number": 3,
        "title": "Extension Nine",
        "setup": "Operator Nine stops trying to control the story and uses the switchboard to connect the people who actually need each other. The callers do the hard part themselves.",
        "priorEvent": "Caller B's fake future emergency crashes into Caller A's line before the transfer finishes."
      }
    ],
    "cues": [
      {
        "number": 1,
        "id": "switch-v2-c01",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Department of Unfinished Business. Operator Nine speaking. Which impossibility may I direct today?",
        "directionText": "Choose one flashing line and answer like impossible calls are completely routine.",
        "spokenDirectionText": "Answer the line.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 2,
        "id": "switch-v2-c02",
        "actor": "Caller A",
        "kind": "objective",
        "act": 1,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "You lost a feeling",
        "text": "Describe the missing feeling only through weather, temperature, body sensations, and one strange physical detail. Do not name the feeling yet. Make it clear that losing it has changed how you act.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 3,
        "id": "switch-v2-c03",
        "actor": "Operator Nine",
        "kind": "objective",
        "act": 1,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Solve it neatly",
        "text": "Accept every claim as ordinary. Ask precise questions and try to classify the missing feeling into a department. Your goal is a clean transfer, not a deep conversation.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 4,
        "id": "switch-v2-c04",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "I can transfer you to Weather Inside the Human Body, but they close whenever anyone cries.",
        "directionText": "Write a note, then sound completely certain that you found the answer.",
        "spokenDirectionText": "Write it down.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 5,
        "id": "switch-v2-c05",
        "actor": "Caller A",
        "kind": "objective",
        "act": 1,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Wrong department",
        "text": "Reject the department. Add one clue that makes the missing feeling funny on the surface but important underneath. Mention one memory connected to the person involved without naming that person.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 6,
        "id": "switch-v2-c06",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Then I believe you misplaced either courage or the feeling that makes people return shopping carts.",
        "directionText": "Make one confident guess based on the caller's clues.",
        "spokenDirectionText": "Make a guess.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 7,
        "id": "switch-v2-c07",
        "actor": "Caller A",
        "kind": "objective",
        "act": 1,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Too close",
        "text": "React as if Operator Nine got dangerously close. Reveal that the feeling disappeared after you said or did something you wish you could take back. Do not name the other person yet.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 8,
        "id": "switch-v2-c08",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 1,
        "dialogue": "Stay with me. One clean transfer and we can both pretend this call was normal.",
        "directionText": "Reach toward the transfer controls and prepare to route Caller A.",
        "spokenDirectionText": "Hold the transfer.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 9,
        "id": "switch-v2-c09",
        "actor": "group",
        "kind": "public",
        "act": 1,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Act I disaster - the second line crashes in",
        "text": "Before Operator Nine can complete the transfer, another line bursts through the same channel. Caller B enters with a civilization-level warning from tomorrow: every spoon will vanish at noon. For one brief moment, Caller A and Caller B can hear each other. Operator Nine's neat final call has become two tangled calls.",
        "directorVoice": true,
        "requireAck": false
      },
      {
        "number": 10,
        "id": "switch-v2-c10",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "Thank you for contacting Yesterday Support. Please state the exact future disaster and whether forks are affected.",
        "directionText": "Switch to Caller B's line without losing your calm.",
        "spokenDirectionText": "Switch lines.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 11,
        "id": "switch-v2-c11",
        "actor": "Caller B",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Future evidence",
        "text": "Invent one piece of proof that the spoon crisis is real. Accidentally mention a sound, object, smell, or tiny detail from the room you share with Caller A.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 12,
        "id": "switch-v2-c12",
        "actor": "group",
        "kind": "public",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "The lines cross",
        "text": "The switchboard crosses the lines fully. Both callers can now hear each other. Each caller must recognize one detail in the other person's story that should be impossible to know.",
        "directorVoice": true,
        "requireAck": false
      },
      {
        "number": 13,
        "id": "switch-v2-c13",
        "actor": "Caller A",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Test the room",
        "text": "Suspect Caller B is physically close to you. Ask one question that can prove it without directly asking where Caller B is.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 14,
        "id": "switch-v2-c14",
        "actor": "Caller B",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Protect tomorrow",
        "text": "Keep claiming you are calling from tomorrow while answering Caller A's test. Let one obvious contradiction slip.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 15,
        "id": "switch-v2-c15",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "I regret to inform both of you that tomorrow appears to be sitting in the same room as today.",
        "directionText": "Listen to both callers, then cut in when the contradiction becomes obvious.",
        "spokenDirectionText": "Interrupt them.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 16,
        "id": "switch-v2-c16",
        "actor": "Operator Nine",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Separate the mess",
        "text": "Your perfect routing plan is collapsing. Instead of asking why the callers are connected, try to save the call by assigning each person a different department.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 17,
        "id": "switch-v2-c17",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "I am separating these lines before time, feelings, and silverware become one department.",
        "directionText": "Move the imaginary plugs or controls as if you can force the calls apart.",
        "spokenDirectionText": "Move the plugs.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 18,
        "id": "switch-v2-c18",
        "actor": "group",
        "kind": "public",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Transfer failed",
        "text": "The switchboard refuses the transfer. Announce or react to this message: SHARED ORIGIN. LINES CANNOT BE SEPARATED. Both callers stay connected.",
        "directorVoice": true,
        "requireAck": false
      },
      {
        "number": 19,
        "id": "switch-v2-c19",
        "actor": "Caller A",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Stop hiding",
        "text": "Confront Caller B about one detail that proves the tomorrow story is fake. Let your anger cover embarrassment or hurt.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 20,
        "id": "switch-v2-c20",
        "actor": "Caller B",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Admit the fake emergency",
        "text": "Admit that the spoon disaster is fake. Explain that you made the call because Caller A would talk to a stranger at a switchboard but would not talk honestly to you. Do not solve the conflict yet.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 21,
        "id": "switch-v2-c21",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 2,
        "dialogue": "You created a spoon apocalypse because saying, \"Can we talk?\" felt too difficult?",
        "directionText": "Look from one line to the other and let the absurd truth land.",
        "spokenDirectionText": "Look at both lines.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 22,
        "id": "switch-v2-c22",
        "actor": "Caller A",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Name what was lost",
        "text": "Name the missing feeling now. Tie it to the real event between you and Caller B. Say what you have been afraid would happen if you spoke honestly.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 23,
        "id": "switch-v2-c23",
        "actor": "Caller B",
        "kind": "objective",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Answer for real",
        "text": "Drop the future voice. Respond to Caller A's fear honestly. Admit what you hoped would happen when you created the fake call and what you are afraid of too.",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 24,
        "id": "switch-v2-c24",
        "actor": "group",
        "kind": "public",
        "act": 2,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Darkest point - no department",
        "text": "The board has no valid department for the problem. The only working option is MANUAL BRIDGE. Using it will mark Operator Nine's final call as a misroute and end the perfect routing record. Operator Nine must choose between protecting the record and directly connecting the two callers.",
        "directorVoice": true,
        "requireAck": false
      },
      {
        "number": 25,
        "id": "switch-v2-c25",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Forget the routing record. I am opening both lines. You two need each other, not another department.",
        "directionText": "Release the separate controls and deliberately open the manual bridge.",
        "spokenDirectionText": "Open both lines.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 26,
        "id": "switch-v2-c26",
        "actor": "selected group",
        "kind": "Caller A + Caller B",
        "act": 3,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "One honest sentence each",
        "text": "Speak directly to each other. Caller A says one honest sentence about the lost feeling. Caller B answers with one honest sentence. No jokes until both honest sentences are finished. Then either person may break the tension with one small spoon callback.",
        "directorVoice": false,
        "requireAck": true
      },
      {
        "number": 27,
        "id": "switch-v2-c27",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "I have your department. Connecting both of you to Difficult Conversations, extension nine. Unfortunately, you are already there.",
        "directionText": "Make one final ceremonial transfer even though the callers are already connected.",
        "spokenDirectionText": "Make the transfer.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 28,
        "id": "switch-v2-c28",
        "actor": "Operator Nine",
        "kind": "fixed dialogue",
        "act": 3,
        "dialogue": "Switchboard Nine signing off. All spoons accounted for. One impossible call completed. Apparently the right transfer was no transfer at all.",
        "directionText": "Finish the final shift, then remove your headset or mime doing so.",
        "spokenDirectionText": "Remove your headset.",
        "label": "",
        "text": "",
        "directorVoice": false,
        "requireAck": false
      },
      {
        "number": 29,
        "id": "switch-v2-ending",
        "actor": "ending",
        "kind": "ending",
        "act": 3,
        "dialogue": "",
        "directionText": "",
        "spokenDirectionText": "",
        "label": "Choose the last image",
        "text": "Caller A and Caller B decide whether to hang up and talk face to face, remain on the line while sitting in the same room, or silently pass one ordinary spoon between them as a peace offering. Operator Nine leaves the board knowing the last call was not perfect on paper, but it helped the right people finally speak.",
        "directorVoice": false,
        "requireAck": true
      }
    ],
    "approvedScript": "Switchboard 9 - Google Docs Rebuild\nstoryId: improv-switchboard\nCategory: Improv\nMode: improv\nTarget duration: 12–18 minutes\nSource checked: src/data/demoScenario.js\nSource SHA-256: d753f4ffcc4807195f47861bf52dd78497cc5c2050fba4e28589209d0cb38122\nCue count: 29 total (11 fixed dialogue + 17 objective/group beats + 1 ending)\nProtagonist: Operator Nine\n\n\nArc: Operator Nine wants one perfect final call before leaving the switchboard. Nine believes a good operator solves every problem by finding the exact department and keeping every line neat. The harder Nine tries to separate the callers, the more the switchboard proves their problems belong together. At the darkest point, the only helpful choice is a manual bridge that will end Nine's perfect routing record. Nine gives up the record, connects the callers directly, and learns that helping people matters more than making the call look perfect.\n\n\nVoice metadata: Preserve the current QLine or retained-edition voice assignments for Operator Nine, Caller A, and Caller B. No explicit voice IDs are stored in the demoScenario.js story source inspected in this pass.\n\n\nCharacter Briefs\nOperator Nine: This is your final shift. You want one perfect call before you leave. You are calm because you know every department and every rule. Your weakness is that you treat a strange human problem like a routing problem. You hate crossed lines and hate admitting that the right answer may be no transfer at all. Keep both callers connected and help them without disconnecting anyone.\nCaller A: You called the Department of Lost Things because you have lost a feeling, not an object. The feeling disappeared after a painful moment with someone close to you. Describe it through weather, temperature, body feelings, and memories before you name it. You want Operator Nine to guess because saying the feeling out loud would make the real problem harder to avoid.\nCaller B: You claim you are calling from tomorrow because every spoon will vanish at noon. You are really in the same room as Caller A. The future emergency is fake. You invented it because Caller A has been avoiding a hard conversation with you, and you hoped a ridiculous crisis might make the two of you talk. Keep the future story alive as long as you can, but let real details from the room slip out.\n\n\nAct I - One Perfect Call\nSetup: Operator Nine begins the final shift wanting one clean, perfect call. Caller A reports losing something that cannot be placed in a box. Nine tries to solve the problem by finding the correct department instead of noticing that the caller needs a person more than a transfer.\n\n\nCue 01 | switch-v2-c01 | Operator Nine | fixed dialogue\ndialogue: Department of Unfinished Business. Operator Nine speaking. Which impossibility may I direct today?\ndirectionText: Choose one flashing line and answer like impossible calls are completely routine.\nspokenDirectionText: Answer the line.\n\n\nCue 02 | switch-v2-c02 | Caller A | objective\nlabel: You lost a feeling\ntext: Describe the missing feeling only through weather, temperature, body sensations, and one strange physical detail. Do not name the feeling yet. Make it clear that losing it has changed how you act.\n\n\nCue 03 | switch-v2-c03 | Operator Nine | objective\nlabel: Solve it neatly\ntext: Accept every claim as ordinary. Ask precise questions and try to classify the missing feeling into a department. Your goal is a clean transfer, not a deep conversation.\n\n\nCue 04 | switch-v2-c04 | Operator Nine | fixed dialogue\ndialogue: I can transfer you to Weather Inside the Human Body, but they close whenever anyone cries.\ndirectionText: Write a note, then sound completely certain that you found the answer.\nspokenDirectionText: Write it down.\n\n\nCue 05 | switch-v2-c05 | Caller A | objective\nlabel: Wrong department\ntext: Reject the department. Add one clue that makes the missing feeling funny on the surface but important underneath. Mention one memory connected to the person involved without naming that person.\n\n\nCue 06 | switch-v2-c06 | Operator Nine | fixed dialogue\ndialogue: Then I believe you misplaced either courage or the feeling that makes people return shopping carts.\ndirectionText: Make one confident guess based on the caller's clues.\nspokenDirectionText: Make a guess.\n\n\nCue 07 | switch-v2-c07 | Caller A | objective\nlabel: Too close\ntext: React as if Operator Nine got dangerously close. Reveal that the feeling disappeared after you said or did something you wish you could take back. Do not name the other person yet.\n\n\nCue 08 | switch-v2-c08 | Operator Nine | fixed dialogue\ndialogue: Stay with me. One clean transfer and we can both pretend this call was normal.\ndirectionText: Reach toward the transfer controls and prepare to route Caller A.\nspokenDirectionText: Hold the transfer.\n\n\nCue 09 | switch-v2-c09 | group | public\nlabel: Act I disaster - the second line crashes in\ntext: Before Operator Nine can complete the transfer, another line bursts through the same channel. Caller B enters with a civilization-level warning from tomorrow: every spoon will vanish at noon. For one brief moment, Caller A and Caller B can hear each other. Operator Nine's neat final call has become two tangled calls.\ndirectorVoice: true\n\n\nAct I disaster: Nine's need for one perfect, orderly call is broken. A second caller crashes into the first line, and the two problems begin touching each other before Nine is ready.\n\n\nAct II - Crossed Wires\nRising action: Operator Nine tries to restore order by separating the calls. Instead, each new clue proves the calls share the same room and the same real problem.\n\n\nCue 10 | switch-v2-c10 | Operator Nine | fixed dialogue\ndialogue: Thank you for contacting Yesterday Support. Please state the exact future disaster and whether forks are affected.\ndirectionText: Switch to Caller B's line without losing your calm.\nspokenDirectionText: Switch lines.\n\n\nCue 11 | switch-v2-c11 | Caller B | objective\nlabel: Future evidence\ntext: Invent one piece of proof that the spoon crisis is real. Accidentally mention a sound, object, smell, or tiny detail from the room you share with Caller A.\n\n\nCue 12 | switch-v2-c12 | group | public\nlabel: The lines cross\ntext: The switchboard crosses the lines fully. Both callers can now hear each other. Each caller must recognize one detail in the other person's story that should be impossible to know.\ndirectorVoice: true\n\n\nCue 13 | switch-v2-c13 | Caller A | objective\nlabel: Test the room\ntext: Suspect Caller B is physically close to you. Ask one question that can prove it without directly asking where Caller B is.\n\n\nCue 14 | switch-v2-c14 | Caller B | objective\nlabel: Protect tomorrow\ntext: Keep claiming you are calling from tomorrow while answering Caller A's test. Let one obvious contradiction slip.\n\n\nCue 15 | switch-v2-c15 | Operator Nine | fixed dialogue\ndialogue: I regret to inform both of you that tomorrow appears to be sitting in the same room as today.\ndirectionText: Listen to both callers, then cut in when the contradiction becomes obvious.\nspokenDirectionText: Interrupt them.\n\n\nCue 16 | switch-v2-c16 | Operator Nine | objective\nlabel: Separate the mess\ntext: Your perfect routing plan is collapsing. Instead of asking why the callers are connected, try to save the call by assigning each person a different department.\n\n\nCue 17 | switch-v2-c17 | Operator Nine | fixed dialogue\ndialogue: I am separating these lines before time, feelings, and silverware become one department.\ndirectionText: Move the imaginary plugs or controls as if you can force the calls apart.\nspokenDirectionText: Move the plugs.\n\n\nCue 18 | switch-v2-c18 | group | public\nlabel: Transfer failed\ntext: The switchboard refuses the transfer. Announce or react to this message: SHARED ORIGIN. LINES CANNOT BE SEPARATED. Both callers stay connected.\ndirectorVoice: true\n\n\nCue 19 | switch-v2-c19 | Caller A | objective\nlabel: Stop hiding\ntext: Confront Caller B about one detail that proves the tomorrow story is fake. Let your anger cover embarrassment or hurt.\n\n\nCue 20 | switch-v2-c20 | Caller B | objective\nlabel: Admit the fake emergency\ntext: Admit that the spoon disaster is fake. Explain that you made the call because Caller A would talk to a stranger at a switchboard but would not talk honestly to you. Do not solve the conflict yet.\n\n\nCue 21 | switch-v2-c21 | Operator Nine | fixed dialogue\ndialogue: You created a spoon apocalypse because saying, \"Can we talk?\" felt too difficult?\ndirectionText: Look from one line to the other and let the absurd truth land.\nspokenDirectionText: Look at both lines.\n\n\nCue 22 | switch-v2-c22 | Caller A | objective\nlabel: Name what was lost\ntext: Name the missing feeling now. Tie it to the real event between you and Caller B. Say what you have been afraid would happen if you spoke honestly.\n\n\nCue 23 | switch-v2-c23 | Caller B | objective\nlabel: Answer for real\ntext: Drop the future voice. Respond to Caller A's fear honestly. Admit what you hoped would happen when you created the fake call and what you are afraid of too.\n\n\nCue 24 | switch-v2-c24 | group | public\nlabel: Darkest point - no department\ntext: The board has no valid department for the problem. The only working option is MANUAL BRIDGE. Using it will mark Operator Nine's final call as a misroute and end the perfect routing record. Operator Nine must choose between protecting the record and directly connecting the two callers.\ndirectorVoice: true\n\n\nDarkest point: Nine can preserve the perfect record only by continuing to treat the callers like separate routing problems. The helpful choice will make the final shift look imperfect.\n\n\nAct III - Extension Nine\nResolution: Operator Nine stops trying to control the story and uses the switchboard to connect the people who actually need each other. The callers do the hard part themselves.\n\n\nCue 25 | switch-v2-c25 | Operator Nine | fixed dialogue\ndialogue: Forget the routing record. I am opening both lines. You two need each other, not another department.\ndirectionText: Release the separate controls and deliberately open the manual bridge.\nspokenDirectionText: Open both lines.\n\n\nCue 26 | switch-v2-c26 | selected group | Caller A + Caller B\nlabel: One honest sentence each\ntext: Speak directly to each other. Caller A says one honest sentence about the lost feeling. Caller B answers with one honest sentence. No jokes until both honest sentences are finished. Then either person may break the tension with one small spoon callback.\nrequireAck: true\n\n\nCue 27 | switch-v2-c27 | Operator Nine | fixed dialogue\ndialogue: I have your department. Connecting both of you to Difficult Conversations, extension nine. Unfortunately, you are already there.\ndirectionText: Make one final ceremonial transfer even though the callers are already connected.\nspokenDirectionText: Make the transfer.\n\n\nCue 28 | switch-v2-c28 | Operator Nine | fixed dialogue\ndialogue: Switchboard Nine signing off. All spoons accounted for. One impossible call completed. Apparently the right transfer was no transfer at all.\ndirectionText: Finish the final shift, then remove your headset or mime doing so.\nspokenDirectionText: Remove your headset.\n\n\nCue 29 | switch-v2-ending | ending | selected group\nlabel: Choose the last image\ntext: Caller A and Caller B decide whether to hang up and talk face to face, remain on the line while sitting in the same room, or silently pass one ordinary spoon between them as a peace offering. Operator Nine leaves the board knowing the last call was not perfect on paper, but it helped the right people finally speak.\nrequireAck: true\n\n\nStory Check\nBeginning: Operator Nine wants one perfect final call. Caller A brings a strange emotional problem, and Nine tries to solve it with clean routing.\nAct I disaster: Caller B's fake future emergency crashes into Caller A's line before the transfer finishes.\nAct II: Nine keeps trying to separate the calls. Shared room details, contradictions, and the failed transfer prove the callers belong in the same problem. Caller B admits the fake emergency, and Caller A finally names the lost feeling.\nDarkest point: The board offers only a manual bridge that will ruin Nine's perfect routing record.\nAct III: Nine chooses the callers over the record, opens both lines, and lets them speak directly. The Difficult Conversations line becomes a payoff instead of just a joke.\nCharacter arc: Operator Nine moves from controlling every problem through perfect routing to using the switchboard as a tool for real connection.\nComedy: The lost feeling, Weather Inside the Human Body, shopping carts, the spoon apocalypse, Yesterday Support, shared-origin warning, and Difficult Conversations all grow from the same central problem instead of feeling random.\nCause and effect: Nine tries to transfer Caller A. Caller B's interruption tangles the lines. B's room details expose the shared location. Nine's attempt to separate them triggers the shared-origin failure. That failure forces the truth out. The manual bridge threatens Nine's perfect record, and giving up the record becomes the choice that solves the real problem.\nLive direction check: All 11 fixed dialogue cues use spokenDirectionText of four words or fewer."
  }
};

const actorIds = { Mara: 'mara', Dev: 'dev', Luz: 'luz', Ada: 'ada', Ben: 'ben', 'Operator Nine': 'operator', 'Caller A': 'caller-a', 'Caller B': 'caller-b' };

function characterBriefs(story) {
  return Object.fromEntries(story.briefs.map((brief) => {
    const divider = brief.includes(' | ') ? ' | ' : ': ';
    const cut = brief.indexOf(divider);
    if (cut < 0) throw new Error('Approved character brief has no name separator.');
    const name = brief.slice(0, cut), characterId = actorIds[name];
    if (!characterId) throw new Error('Unknown approved character brief: ' + name);
    return [characterId, brief.slice(cut + divider.length)];
  }));
}

export function buildApprovedStory(base, key) {
  const story = approvedStoryRebuilds[key];
  if (!story || base.id !== (key === 'garden' || key === 'paper' ? 'family-' : '') + story.storyId)
    throw new Error('Approved rebuild does not match this scenario.');
  const briefs = characterBriefs(story), firstLocation = base.scenes[0]?.location || 'Rehearsal space';
  const familySettings = key === 'garden' || key === 'paper' ? productionSetups[base.id]?.scenes : null;
  const sceneIds = Object.fromEntries(story.acts.map(act => [act.number, key + '-act-' + act.number]));
  const scenes = story.acts.map((act, index) => ({
    id: sceneIds[act.number], number: act.number, title: act.title,
    location: familySettings?.[index]?.setting || firstLocation,
    setting: familySettings?.[index]?.setting || base.scenes[Math.min(index, base.scenes.length - 1)]?.setting || firstLocation,
    situation: act.setup,
    ...(index ? { priorEvent: story.acts[index - 1].priorEvent || story.acts[index - 1].setup } : {}),
    tone: base.scenes[Math.min(index, base.scenes.length - 1)]?.tone || 'Stay present and listen.',
  }));
  const cues = story.cues.map(cue => {
    const common = { id: cue.id, sceneId: sceneIds[cue.act], label: cue.label || 'Cue ' + String(cue.number).padStart(2, '0') };
    if (cue.kind === 'fixed dialogue') {
      const characterId = actorIds[cue.actor];
      if (!characterId) throw new Error('Unknown fixed-dialogue character: ' + cue.actor);
      return { ...common, type: 'dialogue', visibility: 'character', characterId,
        directionText: cue.directionText, spokenDirectionText: cue.spokenDirectionText,
        dialogueText: cue.dialogue, requireAck: true };
    }
    if (cue.kind === 'objective') {
      const characterId = actorIds[cue.actor];
      if (!characterId) throw new Error('Unknown objective character: ' + cue.actor);
      return { ...common, type: 'objective', visibility: 'character', characterId, text: cue.text, requireAck: true };
    }
    if (cue.kind === 'public' && cue.actor === 'group')
      return { ...common, type: 'group', visibility: 'public', text: cue.text, directorVoice: cue.directorVoice };
    if (cue.kind === 'Caller A + Caller B' && cue.actor === 'selected group')
      return { ...common, type: 'group', visibility: 'selected', characterIds: ['caller-a', 'caller-b'], text: cue.text, requireAck: cue.requireAck };
    if (cue.kind === 'ending')
      return { ...common, type: 'ending', visibility: 'selected', characterIds: base.characters.map(character => character.id), text: cue.text, requireAck: true };
    throw new Error('Unsupported approved cue: ' + cue.id + ' / ' + cue.kind);
  });
  const actorBriefs = scenes.flatMap(scene => base.characters.filter(character => briefs[character.id]).map(character => ({
    id: 'brief-' + scene.id + '-' + character.id, sceneId: scene.id, characterId: character.id,
    source: 'director', text: briefs[character.id],
  })));
  return {
    ...base,
    category: story.category || base.category,
    logline: key === 'garden' ? 'Ben must choose whether to give Mrs. Bell the best apple after the basket breaks.'
      : key === 'paper' ? 'Ada learns to slow down and work with Ben when their paper bridge fails twice.' : base.logline,
    description: story.arc,
    characters: base.characters.map(character => ({ ...character, objective: briefs[character.id] || character.objective })),
    scenes, cues, script: [], actorBriefs, originalScript: story.approvedScript,
  };
}
